import React, { useState } from "react";
import "./panel.scss";
import SiteTexts from "utils/Texts";
import CheckBoxInput from "components/CheckBoxInput/CheckBoxInput";
import { Labels } from "utils/Labels";
import DefaultSelectInput from "components/SelectInput/SelectInput";
import TextInput from "components/Input/TextInput";
import Map from "components/Map/map";
import { defaultLocationType } from "components/Map/map";

interface Props {
  items: any;
  typeEdit: boolean;
  setTypeEdit: React.Dispatch<React.SetStateAction<boolean>>;
  typeAdd: boolean;
  setTypeAdd: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedSectionId: React.Dispatch<React.SetStateAction<string>>;
  selectedSectionId: number;
  faNameEdit: string;
  setFaNameEdit: React.Dispatch<React.SetStateAction<string>>;
  engNameEdit: string;
  setEngNameEdit: React.Dispatch<React.SetStateAction<string>>;
  errorFaNameEdit: string;
  errorEngNameEdit: string;
  faNameAdd: string;
  setFaNameAdd: React.Dispatch<React.SetStateAction<string>>;
  engNameAdd: string;
  setEngNameAdd: React.Dispatch<React.SetStateAction<string>>;
  errorFaNameAdd: string;
  errorEngNameAdd: string;
  setLocation: React.Dispatch<React.SetStateAction<any>>;
  location: defaultLocationType;
  addRegionFunc: () => void;
  regionData: any;
  setSelectedRegionId: React.Dispatch<React.SetStateAction<string>>;
  showEditRegionData: boolean;
  editRegionFunc: () => void;
  newItem: string;
  setNewItem: React.Dispatch<React.SetStateAction<string>>;
  errorNewItem: string;
  showAddInput: boolean;
  addItemFunc: () => void;
  existingItems: any;
  setSelectedItemForEditId: React.Dispatch<React.SetStateAction<string>>;
  editItem: string;
  setEditItem: React.Dispatch<React.SetStateAction<string>>;
  errorEditItem: string;
  editItemFunc: () => void;
  showEditInput: boolean;
}

const  BaseInfoMobilePage: React.FC<Props> = ({
  items,
  typeEdit,
  setTypeEdit,
  typeAdd,
  setTypeAdd,
  setSelectedSectionId,
  selectedSectionId,
  faNameEdit,
  setFaNameEdit,
  engNameEdit,
  setEngNameEdit,
  errorFaNameEdit,
  errorEngNameEdit,
  faNameAdd,
  setFaNameAdd,
  engNameAdd,
  setEngNameAdd,
  errorFaNameAdd,
  errorEngNameAdd,
  setLocation,
  location,
  addRegionFunc,
  regionData,
  setSelectedRegionId,
  showEditRegionData,
  editRegionFunc,
  newItem,
  setNewItem,
  errorNewItem,
  showAddInput,
  addItemFunc,
  existingItems,
  setSelectedItemForEditId,
  editItem,
  setEditItem,
  errorEditItem,
  editItemFunc,
  showEditInput,
}) => {
  const SiteText = SiteTexts();

  return (
    <div className="base-info-parent">
      <h4>{SiteText.BASE_INFO.TITLE}</h4>
      <p className="description">{SiteText.BASE_INFO.DESCRIPTION}</p>
      <div className="inputs-parent">
        <div className="text-input-parent" style={{width: "50%"}}>
          <CheckBoxInput
            lableText={Labels.InputLabels.Add}
            className={
              !typeAdd
                ? "general-checkbox-input"
                : "general-checkbox-input checked"
            }
            onChangeFunction={setTypeAdd}
            value={typeAdd}
          />
        </div>
        <div className="text-input-parent" style={{width: "50%"}}>
          <CheckBoxInput
            
            lableText={Labels.InputLabels.Edit}
            className={
              !typeEdit
                ? "general-checkbox-input"
                : "general-checkbox-input checked"
            }
            onChangeFunction={setTypeEdit}
            value={typeEdit}
          />
        </div>
        <div className="text-input-parent"></div>
        <div className="text-input-parent">
          <DefaultSelectInput
            lable={Labels.InputLabels.Item}
            list={items}
            className={"general-select-input"}
            error={""}
            required={true}
            name={"inpute-item"}
            onChangeValue={setSelectedSectionId}
          />
        </div>
      </div>
      {selectedSectionId === 0 && typeAdd === true ? (
        // ADD REGION
        <form onSubmit={addRegionFunc}>
          <div className="inputs-parent">
            <div className="text-input-parent">
              <TextInput
                key={1}
                lable={Labels.InputLabels.EngName}
                className={
                  "general-select-input" + (errorEngNameAdd ? " error" : "")
                }
                error={errorEngNameAdd}
                required={true}
                name={"inpute-eng-name"}
                value={engNameAdd}
                onChangeValue={setEngNameAdd}
                autoFocus={false}
                regex={""}
                type={"text"}
                removeLable={false}
                maxlength={200}
              />
            </div>
            <div className="text-input-parent">
              <TextInput
                key={2}
                lable={Labels.InputLabels.FaName}
                className={
                  "general-select-input fa-input" +
                  (errorFaNameAdd ? " error" : "")
                }
                error={errorFaNameAdd}
                required={true}
                name={"inpute-fa-name"}
                value={faNameAdd}
                onChangeValue={setFaNameAdd}
                autoFocus={false}
                regex={""}
                type={"text"}
                removeLable={false}
                maxlength={200}
                direction={"rtl"}
              />
            </div>
            <div className="text-input-parent"></div>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                borderRadius: "5px",
                zIndex: "1",
                marginTop: "10px",
              }}
            >
              <Map changeMarker={setLocation} location={location} />
            </div>
            <div className="submit-btn-parent">
              <button onSubmit={addRegionFunc}>
                {Labels.ButtonLabels.Add}
              </button>
            </div>
          </div>
        </form>
      ) : selectedSectionId === 0 && typeEdit === true ? (
        // EDIT REGION
        <form onSubmit={editRegionFunc}>
          <div className="inputs-parent">
            <div className="text-input-parent">
              <DefaultSelectInput
                lable={Labels.InputLabels.Region}
                list={regionData}
                className={"general-select-input"}
                error={""}
                required={true}
                name={"inpute-region-data"}
                onChangeValue={setSelectedRegionId}
              />
            </div>
            {showEditRegionData === true ? (
              <>
                <div className="text-input-parent">
                  <TextInput
                    key={3}
                    lable={Labels.InputLabels.EngName}
                    className={
                      "general-select-input" +
                      (errorEngNameEdit ? " error" : "")
                    }
                    error={errorEngNameEdit}
                    required={true}
                    name={"inpute-eng-name"}
                    value={engNameEdit}
                    onChangeValue={setEngNameEdit}
                    autoFocus={false}
                    regex={""}
                    type={"text"}
                    removeLable={false}
                    maxlength={200}
                  />
                </div>
                <div className="text-input-parent">
                  <TextInput
                    key={4}
                    lable={Labels.InputLabels.FaName}
                    className={
                      "general-select-input fa-input" +
                      (errorFaNameEdit ? " error" : "")
                    }
                    error={errorFaNameEdit}
                    required={true}
                    name={"inpute-fa-name"}
                    value={faNameEdit}
                    onChangeValue={setFaNameEdit}
                    autoFocus={false}
                    regex={""}
                    type={"text"}
                    removeLable={false}
                    maxlength={200}
                    direction={"rtl"}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: "5px",
                    zIndex: "1",
                    marginTop: "10px",
                  }}
                >
                  <Map changeMarker={setLocation} location={location} />
                </div>
                <div className="submit-btn-parent">
                  <button onSubmit={editRegionFunc}>
                    {Labels.ButtonLabels.Edit}
                  </button>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </form>
      ) : typeAdd === true &&
        selectedSectionId !== undefined &&
        showAddInput == true ? (
        <form onSubmit={addItemFunc}>
          <div className="inputs-parent">
            <div className="text-input-parent">
              <TextInput
                key={5}
                lable={Labels.InputLabels.AddNewItem}
                className={
                  "general-select-input" +
                  (errorNewItem ? " error" : "")
                }
                error={errorNewItem}
                required={true}
                name={"inpute-new-item"}
                value={newItem}
                onChangeValue={setNewItem}
                autoFocus={false}
                regex={""}
                type={"text"}
                removeLable={false}
                maxlength={200}
              />
            </div>
            <div style={{ width: "100%", zIndex: "1" }}>
              <p style={{ fontSize: "14px" }}>Existing Items: </p>
              <p style={{ fontSize: "14px", marginTop: "10px" }}>
                {existingItems.map((item: any, key: number) =>
                  existingItems.length - 1 === key ? (
                    <span key={key}>{item.title} </span>
                  ) : (
                    <span key={key}>{item.title}, </span>
                  )
                )}
              </p>
            </div>
            <div className="submit-btn-parent">
              <button onSubmit={addItemFunc}>{Labels.ButtonLabels.Add}</button>
            </div>
          </div>
        </form>
      ) : typeEdit === true && selectedSectionId !== undefined ? (
        <form onSubmit={editItemFunc}>
          <div className="inputs-parent">
            <div className="text-input-parent">
              <DefaultSelectInput
                lable={Labels.InputLabels.ExistItems}
                list={existingItems}
                className={"general-select-input"}
                error={""}
                required={true}
                name={"inpute-existing-selected-item"}
                onChangeValue={setSelectedItemForEditId}
              />
            </div>
            {showEditInput === true ? (
              <>
                <div className="text-input-parent">
                  <TextInput
                    key={6}
                    lable={Labels.InputLabels.EditNewItem}
                    className={
                      "general-select-input" + (errorEditItem ? " error" : "")
                    }
                    error={errorEditItem}
                    required={true}
                    name={"inpute-edit-item"}
                    value={editItem}
                    onChangeValue={setEditItem}
                    autoFocus={false}
                    regex={""}
                    type={"text"}
                    removeLable={false}
                    maxlength={200}
                  />
                </div>
                <div className="text-input-parent"></div>
                <div className="submit-btn-parent">
                  <button onSubmit={editItemFunc}>
                    {Labels.ButtonLabels.Edit}
                  </button>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </form>
      ) : (
        <></>
      )}
    </div>
  );
};

export default  BaseInfoMobilePage;

// (
//   <span>{item.title}, </span>
// )

